/**
 * @generated SignedSource<<b657844859df733d1f0e7bebb4242c1a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_itemSearch" | "SharedSaveSearchContext_itemSearch">;
  readonly " $fragmentType": "PdpRespSidebarButtons_itemSearch";
};
export type PdpRespSidebarButtons_itemSearch$key = {
  readonly " $data"?: PdpRespSidebarButtons_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "518b2c1689eb9261cede0a7507bffeb3";

export default node;
